export default __webpack_public_path__ + "images/logoBabor.f7c4826ae1a494b0a2c08e5af6e867b7.svg"